import { atom } from "jotai";

import type { FilterToken } from "../dsl/types";
import { highlightedIndexAtom } from "./highlight";
import { commandPaletteAtom } from "./state";

export const filterTokensAtom = atom(
  (get) => get(commandPaletteAtom).filterTokens,
  (_get, set, value: FilterToken[]) => {
    set(commandPaletteAtom, (draft) => {
      draft.filterTokens = value;
    });
    set(highlightedIndexAtom, 0);
  },
);

export const addTokenAtom = atom(null, (get, set, token: FilterToken) => {
  const tokens = get(filterTokensAtom);

  const exists = tokens.some(
    (existing) => existing.key === token.key && existing.value === token.value,
  );

  if (!exists) {
    set(filterTokensAtom, [...tokens, token]);
  }
});

export const removeTokenAtom = atom(null, (get, set, index: number) => {
  set(
    filterTokensAtom,
    get(filterTokensAtom).filter((_, i) => i !== index),
  );
});

export const removeLastTokenAtom = atom(null, (get, set) => {
  const tokens = get(filterTokensAtom);

  if (tokens.length > 0) {
    set(filterTokensAtom, tokens.slice(0, -1));
  }
});

/** The "type" tokens as a plain string list — the shape `useGlobalSearch` works with. */
export const selectedTypesAtom = atom((get) =>
  get(filterTokensAtom)
    .filter((token) => "type" === token.key)
    .map((token) => token.value),
);

/** The "id" tokens, parsed to numbers — same key repeated = OR (any of these ids). */
export const selectedIdsAtom = atom((get) =>
  get(filterTokensAtom)
    .filter((token) => "id" === token.key)
    .map((token) => Number(token.value)),
);
